import _ from 'lodash';
import type { UnknownAction } from '@reduxjs/toolkit'

import { 
  INVALIDATE_MEDIA_UPLOAD,
  UPLOAD_MEDIA_REQUEST,
  UPLOADING_MEDIA_FAILED,
  UPLOADING_MEDIA_SUCCEEDED, 
} from '../actions/actionTypes'

import { Media, UploadMediaErrorResponse, UploadMediaRequest, UploadMediaResponse } from '../../types/media';

interface MediaItemState {
  id: string;
  loading: boolean;
  loaded: boolean;
  item: Media | null;
  error: any;
}

interface MediaState{
  [key: string]: MediaItemState
}


export function mediaReducer(state: MediaState = {}, action: UnknownAction) : MediaState {
  switch (action.type) {
    case UPLOAD_MEDIA_REQUEST: {
      const { id } = action.payload as UploadMediaRequest;

      return {
        ...state,
        [id]: {
          loading: true,
          loaded: false,
          id: id,
          item: null,
          error: null
        }
      }
    }

    case UPLOADING_MEDIA_SUCCEEDED: {
      const { id, response } = action.payload as UploadMediaResponse;
      const itemState = state[id] as MediaItemState;
      if(!itemState) {
        return state;
      }

      return {
        ...state,
        [id]: {
          ...itemState,
          loading: false,
          loaded: true,
          item: response
        }
      }
    }

    case UPLOADING_MEDIA_FAILED: {
      const { id, error } = action.payload as UploadMediaErrorResponse;
      const itemState = state[id] ;
      if(!itemState) {
        return state;
      }

      return {
        ...state,
        [id]: {
          ...itemState,
          loading: false,
          loaded: false,
          error: error
        }
      }
    }

    case INVALIDATE_MEDIA_UPLOAD: {
      const id = action.payload as string;
      const itemState = _.omit(state, id);
      return itemState;
    }

    default: {
      return state
    }
  }
}